import React from 'react';
import { useNavigate } from 'react-router-dom';
import Clients from '../Clients/Clients';
import { logoutUser } from '../../services/authService';

const UserPortal = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logoutUser();
    navigate('/login');
  };

  return (
    <div style={{ backgroundColor: '#0f172a', minHeight: '100vh', padding: '20px' }}>
      <header style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '30px',
        backgroundColor: '#1e293b',
        padding: '15px 30px',
        borderRadius: '12px'
      }}>
        <h1 style={{ color: 'white', margin: 0, fontSize: '24px' }}>Ananta Employee Portal</h1>
        <button 
          onClick={handleLogout}
          style={{ 
            backgroundColor: 'transparent', 
            color: '#ef4444', 
            border: '1px solid #ef4444', 
            padding: '8px 16px', 
            borderRadius: '6px', 
            cursor: 'pointer' 
          }}
        >
          Logout
        </button>
      </header>

      {/* Render the Clients component strictly locked to 'today' */}
      <div style={{ backgroundColor: '#1e293b', borderRadius: '12px', overflow: 'hidden' }}>
        <Clients filter="today" />
      </div>
      
      <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
        <button 
          onClick={() => window.open('/callback-requests', '_blank')}
          style={{
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
          }}
        >
          View Callback Requests (New Tab)
        </button>
      </div>
    </div>
  );
};

export default UserPortal;
